import { type OriginCheckResult, type ScanResultType } from "~/features/scanDmc/types/ScanDMC";
import { resolveApiUrl } from "~/utils/url/urlResolver";

export const redirectToProduct = ({ productCode, dmcCode, type }: Required<OriginCheckResult>) => {
  window.location.href = resolveApiUrl(`/p/${productCode}?scanResult=${type}&dmcCode=${dmcCode}`);
};

export const getScanResultFromUrl = (productCode: string): OriginCheckResult | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const scanResult = urlParams.get("scanResult") as ScanResultType | null;
  if (scanResult) {
    return {
      type: scanResult,
      productCode,
      dmcCode: urlParams.get("dmcCode")!,
    };
  }
  return null;
};

export const appendOverlayParamToUrl = (url: string, overlayValue: boolean) => {
  const urlObject = new URL(url);
  overlayValue ? urlObject.searchParams.append("overlayOpen", "true") : urlObject.searchParams.delete("overlayOpen");
  window.history.replaceState({}, "", urlObject.href);
};
